import { SagaIterator } from 'redux-saga';
import { all, call, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import ddt from '@wix/da-ddt';
import { PapiDaSharedWatchUnsuggest } from '@wix/da-papi-types';
import { requestPuppy } from '@wix/da-http-client';
import { fakeResponse } from './fakeResponse';
import { unsuggestUser, UnsuggestUserPayload } from './actions';

const logger = ddt.createLogger('suggestions');

function* postRequest(url, data) {
  const response = yield call(
    requestPuppy,
    {
      method: 'post',
      url,
      data,
    },
    fakeResponse(url)
  );
  logger.log('POST:response', response);
  return response;
}

function* handleUnsuggestUser(
  action: Action<UnsuggestUserPayload>
): SagaIterator {
  const data = action.payload as UnsuggestUserPayload;
  const response: PapiDaSharedWatchUnsuggest = yield call(
    postRequest,
    'watch/unsuggest',
    data
  );
  if (!response || !response.success) {
    logger.error(response.errorDescription);
    return;
  }
}

export default function* userRootSaga() {
  yield all([takeEvery(unsuggestUser, handleUnsuggestUser)]);
}
